import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function videoReducer(
  state = initialState.VideoData,
  action
) {
  switch (action.type) {
    case types.LOAD_VIDEO_DATA_SUCCESS:
      return action.VideoData;
    default:
      return state;
  }
}
